module.exports = __webpack_public_path__ + "img/loading2.64323189.gif";